import {API_URL} from "../constants";
import axios from "axios";

export const apiDriverCreate = (token: string, {
  fio,
  phone,
  hasMobileAccess,
  password
}: any): any => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/driver/create`, {
        fio,
        phone,
        hasMobileAccess: +(hasMobileAccess === 'Да'),
        password
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const apiDriverUpdate = (token: string, id: number, {
  fio,
  phone,
  hasMobileAccess,
  newPassword
}: any): any => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/driver/update`, {
        id,
        fio,
        phone,
        hasMobileAccess: +(hasMobileAccess === 'Да'),
        password: newPassword
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const apiDriversGet = (token: string, {
  offset, limit, search
}: {
  offset: number,
  limit: number,
  search: string
}): any => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/drivers?offset=${offset}&limit=${limit}&search=${search}`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve({
          elements: response.data.drivers,
          num: response.data.num
        });
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
